"use client"

import type React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { ToolsProvider } from "./tools-context"
import { QueryProvider } from "./query-provider"

interface ProvidersProps {
  children: React.ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryProvider>
      <NextThemesProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <ToolsProvider>
          {children}
        </ToolsProvider>
      </NextThemesProvider>
    </QueryProvider>
  )
}
